import script from "./input-range.vue?vue&type=script&lang=ts&setup=true"
export * from "./input-range.vue?vue&type=script&lang=ts&setup=true"

import "./input-range.vue?vue&type=style&index=0&id=9b0588f0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\T\\jjxliu306\\demo\\search-bar\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b0588f0"]])

export default __exports__